import type { Metadata } from 'next'

export const getMetadata = (metaData: {
  appName: string
  title: string
  url: string
  description: string
  coverImg: string
  author: string
  keywords: string | string[]
  twitterID: string
}): Metadata => ({
  metadataBase: new URL(metaData.url),
  title: {
    template: `%s | ${metaData.appName}`,
    default: metaData.title,
  },
  description: metaData.description,
  applicationName: metaData.appName,
  keywords: metaData.keywords,
  authors: { name: metaData.author },
  creator: metaData.author,
  publisher: metaData.author,
  other: {
    designer: metaData.author,
    language: 'english',
    distribution: 'web',
  },
  manifest: '/manifest.json',
  openGraph: {
    title: {
      template: `%s | ${metaData.appName}`,
      default: metaData.title,
    },
    siteName: metaData.appName,
    description: metaData.description,
    images: [
      {
        url: metaData.coverImg,
        width: 1200,
        height: 627,
      },
    ],
    authors: [metaData.author],
    locale: 'en-US',
    // type: 'website',
  },
  twitter: {
    card: 'summary_large_image',
    title: {
      template: `%s | ${metaData.appName}`,
      default: metaData.title,
    },
    description: metaData.description,
    // siteId: '1467726470533754880',
    creator: metaData.twitterID,
    // creatorId: '1467726470533754880',
    images: [metaData.coverImg],
  },
  icons: {
    icon: '/favicon.ico',
    shortcut: '/favicon.ico',
    apple: '/favicon.ico',
    other: {
      rel: 'apple-touch-icon-precomposed',
      url: '/favicon.ico',
    },
  },
  // robots: {
  //   index: false,
  //   follow: true,
  //   nocache: true,
  //   googleBot: {
  //     index: true,
  //     follow: false,
  //     noimageindex: true,
  //     'max-video-preview': -1,
  //     'max-image-preview': 'large',
  //     'max-snippet': -1,
  //   },
  // },
  appleWebApp: {
    title: metaData.appName,
    statusBarStyle: 'black-translucent',
    startupImage: [
      '/app/startup/apple-touch-startup-image-768x1004.png',
      {
        url: '/app/startup/apple-touch-startup-image-1536x2008.png',
        media: '(device-width: 768px) and (device-height: 1024px)',
      },
    ],
  },
})
